'use client';

import { useEffect, useState } from 'react';
import {
  configurationPageClass,
  configurationPageContentClass,
} from '@modules/configuration/components/configurationLayout';
import { Tabs, TabsContent } from '@shared/components/ui/shadcn/tabs';
import { GroupingAccordion, RejectedAccordion, TabHeader } from '../display/';
import { GeneralSkeleton } from '../skeletons';

export const Main = () => {
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  useEffect(() => {
    // Simular carga inicial de datos
    const timer = setTimeout(() => {
      setIsInitialLoading(false);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  if (isInitialLoading) {
    return <GeneralSkeleton />;
  }

  return (
    <Tabs defaultValue="to_prepare" className={`${configurationPageClass} w-full`}>
      <TabHeader />

      <TabsContent value="to_prepare" className={configurationPageContentClass}>
        <GroupingAccordion />
      </TabsContent>

      <TabsContent value="rejected" className={configurationPageContentClass}>
        <RejectedAccordion />
      </TabsContent>
    </Tabs>
  );
};
